import React from "react";
import { TImageContent } from "./Image.interface";

export const NO_IMAGE_PATH = "assets/images/placeholders/no-image.png";
export const NO_AVATAR_PATH = "assets/images/placeholders/no-avatar.png";
export const LOAD_PLACEHOLDER_IMAGE =
  "assets/images/placeholders/image-empty-placeholder.png";

export interface IImageContext {
  content?: TImageContent;
  empty: {
    [key in TImageContent]: string;
  };
  error: {
    [key in TImageContent]: string;
  };
  wrapper?: React.ElementType;
}

export const ImageContext = React.createContext<IImageContext>({
  content: "default",
  empty: {
    default: NO_IMAGE_PATH,
    person: NO_AVATAR_PATH,
  },
  error: {
    default: NO_IMAGE_PATH,
    person: NO_AVATAR_PATH,
  },
  wrapper: undefined,
});
